import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { restoreCabinet } from 'containers/Configurator/actions/furniture';
import { Color } from 'lib/modelBuilder/entities/Color';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { makeSelectEcoColors } from 'containers/DrawersPanel/selectors';
import ColorPickerList from 'components/ColorPickerList';
import { updateDrawersAction } from 'containers/DrawersPanel/actions';
import ItemPicker from 'helpers/ItemPicker';
import ItemPickerList from 'components/ItemPickerList';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import { PickerTitleCategory } from '../../components/PickerTitleCategory';
import useMedia from 'use-media';

// import styled from 'styled-components/macro';

interface StateProps {
  ecoColors: ItemPicker[];
  lastHistoryCabinet: Cabinet;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  ecoColors: makeSelectEcoColors(),
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
});

const DrawersTypePicker = () => {
  const dispatch = useDispatch();
  const { ecoColors, lastHistoryCabinet } = useSelector(stateSelector);

  const colorSelected = (color: Color, preview: boolean) => {
    dispatch(updateDrawersAction(color, preview));
  };

  const onClickColor = (item: ItemPicker) => {
    colorSelected(item.color as Color, false);
  };

  const onMouseOverColor = (item: ItemPicker) => {
    colorSelected(item.color as Color, true);
  };

  const onLeave = () => {
    // Restore the last history element
    dispatch(restoreCabinet(lastHistoryCabinet));
  };

  const isMobile = useMedia({ maxWidth: 1023 });

  return (
    <div className="mx-2 px-2 px-1">
      {!isMobile && (
        <div className="flex bg-gray-300">
          <PickerTitleCategory selected onClick={() => {}}>
            Eco
          </PickerTitleCategory>
        </div>
      )}
      {ecoColors && (
        <div onMouseLeave={onLeave}>
          <ItemPickerList
            items={ecoColors}
            onClick={onClickColor}
            onDoubleClick={() => {
              dispatch(setColorsPanelAction());
            }}
            onMouseOver={onMouseOverColor}
            big
            wide
          />
        </div>
      )}
    </div>
  );
};

export default DrawersTypePicker;
